var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRespiratory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7959 5.17832C50.0606 11.3596 55.3015 20.8271 57.0638 31.813C57.7515 36.1006 54.4726 40 50.1301 40H42.1409C41.2186 40 40.3054 39.8183 39.4533 39.4654C38.6011 39.1124 37.8269 38.5951 37.1747 37.9429C36.5226 37.2908 36.0052 36.5165 35.6523 35.6644C35.2993 34.8123 35.1177 33.899 35.1177 32.9767V8.75679C35.1177 4.78794 39.7732 2.60637 42.7959 5.17832Z",
    fill: "#00C6A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3593 5.17832C7.0946 11.3596 1.85365 20.8271 0.0914245 31.813C-0.596348 36.1006 2.68264 40 7.02509 40H15.0143C15.9366 40 16.8498 39.8183 17.7019 39.4654C18.5541 39.1124 19.3283 38.5951 19.9805 37.9429C20.6326 37.2908 21.15 36.5165 21.5029 35.6644C21.8559 34.8123 22.0375 33.899 22.0375 32.9767V8.75679C22.0375 4.78794 17.382 2.60637 14.3593 5.17832Z",
    fill: "#00C6A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7103 10.0427V0H26.445V10.0427C26.4436 11.2112 25.9788 12.3315 25.1526 13.1578C24.3264 13.9841 23.2061 14.449 22.0376 14.4504V18.7158C23.2787 18.7152 24.5052 18.4474 25.6337 17.9308C26.7622 17.4141 27.7662 16.6605 28.5776 15.7213C29.389 16.6605 30.393 17.4141 31.5215 17.9308C32.65 18.4475 33.8764 18.7152 35.1176 18.7158V14.4504C33.9491 14.449 32.8288 13.9841 32.0026 13.1578C31.1764 12.3315 30.7116 11.2112 30.7103 10.0427Z",
    fill: "#0088F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRespiratory);
export default __webpack_public_path__ + "static/media/IconRespiratory.78b0d02a4d0f63e702c981a7f94dc4ff.svg";
export { ForwardRef as ReactComponent };